<template>
  <section id="expired" class="d-flex align-center flex-column mt-10">
    <v-icon color="error" size="large" class="text-h1 pb-4">mdi-alert-circle-outline</v-icon>
    <div class="text-h3 pb-6">Your session has expired</div>
    <div class="text-h5 pt-4 pb-4">Please reload the application.</div>
    <div id="buttons">
      <v-btn-primary size="small" block @click="reloadApp">Reload Application</v-btn-primary>
    </div>
  </section>
</template>

<script setup lang="ts">
const reloadApp = () => {
  const queryString = window.location.search;

  const url = queryString.split("=")[1] + "=" + queryString.split("=")[2] + "=" + queryString.split("=")[3];
  window.location.href = url;
};
</script>

<style scoped lang="scss">
.v-application {
  color: rgb(var(--v-theme-dark));
}

.v-application__wrap {
  gap: 1rem;
  //margin: 0 3rem;
}

.layout {
  justify-content: center !important;
  align-items: center !important;
}

section#expired {
  text-align: center;
  height: 100vh;
  width: 100%;
}
</style>
